<template>
  <div class="categoryContainer">
    <Tree class="treeList"
      :isNew="isNew"
      :options="options"
      :activeLinkId="activeLinkId"
      ref="menu">
      <div slot-scope="{ node }" class="item">
        <!-- menu icon -->
        <div :class="{menuIcon: true, active: typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''}">
          <label :for="node.data.id" class="upload"><input type="file" :id="node.data.id" @change="uploadIcon(node, $event)">
            M
          </label>
          <img v-if="typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''" :src="node.data.icon" alt="" />
          <button v-if="typeof (node.data.icon) !== 'undefined' && node.data.icon !== ''" type="button" class="btnDel" @click="delIcon(node)"><span class="blind">remove</span></button>
        </div>
        <!-- //menu icon -->
        <!-- menu icon tablet -->
        <div :class="{menuIcon: true, active: typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''}">
          <label :for="`${node.data.id}_2`" class="upload"><input type="file" :id="`${node.data.id}_2`" @change="uploadIcon(node, $event, 'icon2')">
            T
          </label>
          <img v-if="typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''" :src="node.data.icon2" alt="" />
          <button v-if="typeof (node.data.icon2) !== 'undefined' && node.data.icon2 !== ''" type="button" class="btnDel" @click="delIcon(node, 'icon2')"><span class="blind">remove</span></button>
        </div>
        <!-- //menu icon tablet -->
        <!-- menu label -->
        <div class="listLabel">
          <input type="text" class="input" v-model="node.data.label[langs.current]" placeholder="menu">
          <div v-if="!node.isEditing" class="input" @click.stop="editNode(node)">
            <span v-if="node.data.label[langs.current].trim() === ''" class="placeholder">menu</span>
            {{ node.data.label[langs.current] }}
          </div>
        </div>
        <!-- //menu label -->
        <!-- edit menu item -->
        <div class="edit">
          <div class="editGroup">
            <span class="disaledDevice">
              <input :id="`${node.data.id}_disaledDevice_mobile`" class="mobile" type="checkbox" :checked="node.data.disabledMobile" @change="disabledDevice(node, $event, 'mobile')">
              <label :for="`${node.data.id}_disaledDevice_mobile`"><img src="~@/assets/img/ico_mobile.png" alt=""></label>
            </span>
            <span class="disaledDevice">
              <input :id="`${node.data.id}_disaledDevice_tablet`" class="tablet" type="checkbox" :checked="node.data.disabledTablet" @change="disabledDevice(node, $event, 'tablet')">
              <label :for="`${node.data.id}_disaledDevice_tablet`"><img src="~@/assets/img/ico_tablet.png" alt=""></label>
            </span>
            <button type="button" title="edit menu link" :class="{btnEditLink: true, hasLink: hasLink(node.data), active: isActive(node.data)}" @click.stop="editLink(node, $event)"><img src="~@/assets/img/ico_link.svg" alt=""></button>
            <button type="button" title="edit menu name" @click.stop="editNode(node)"><img src="~@/assets/img/ico_pencil.svg" alt=""></button>
            <button type="button" title="add menu" @click.stop="addChildNode(node)"><img src="~@/assets/img/ico_plus.svg" alt=""></button>
            <button type="button" title="remove menu" @click.stop="removeNode(node)"><img src="~@/assets/img/ico_minus.svg" alt=""></button>
          </div>
        </div>
        <!-- //edit menu item -->
      </div>
    </Tree>
    <button type="button" class="btn btnFull btnWhite btnAdd" @click="addList">+</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UNIQUE from '@/common/unique.js'
import regExp from '@/common/regExp'
import LiquorTree from 'liquor-tree'
import Store from '@/stores'
import UTIL from '@/common/util'

export default {
  name: 'MenuTree',
  props: [
    'locale',
    'isNew',
    'langs',
    'menuId',
    'activeLinkId'
  ],
  components: {
    Tree: LiquorTree
  },
  data () {
    return {
      defaultTree: {
        text: ' ',
        isEditing: false,
        data: {
          icon: '',
          icon2: '',
          target: false,
          type: 'outlink',
          url: this._.cloneDeep(this.langs.langValue),
          label: {},
          pageId: ''
        }
      },
      options: {
        store: {
          store: Store,
          getter: () => {
            return this.treeData
          },
          dispatcher (tree) {
            Store.dispatch('menu/updateTree', tree)
          }
        },
        parentSelect: true,
        dnd: true,
        indeterminate: true,
        autoCheckChildren: false,
        propertyNames: {
          text: 'text',
          data: 'data'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      treeData: 'menu/getTree'
    }),
    menuLabel () {
      const value = this._.cloneDeep(this.langs.langValue)
      Object.keys(value).forEach(v => {
        value[v] = ' '
      })
      return value
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const defaultLang = this.langs.default
      this.defaultTree.data.label = this.menuLabel
      this.$refs.menu.$on('node:editing:start', (node) => {
        node.text = node.data.label[this.langs.current]
      })
      this.$refs.menu.$on('node:editing:stop', (node, isTextChanged) => {
        if (this.isNew) {
          Object.keys(node.data.label).forEach(function (lang) {
            node.data.label[lang] = node.text
          })
        } else {
          node.data.label[this.langs.current] = node.text
        }
        const fillValue = UTIL.fillLangs(node.data.label, node.data.label[defaultLang])
        node.data.label = fillValue
      })
    },
    disabledDevice (node, e, dev) {
      const disabled = e.target.checked
      const toCapitalized = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`
      const disabledDevice = `disabled${toCapitalized(dev)}`
      node.data[disabledDevice] = disabled
      this.$emit('updateTreeData', this.$refs.menu.model)
    },
    uploadIcon (node, e, icon2) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          if (icon2) {
            node.data.icon2 = res.source
          } else {
            node.data.icon = res.source
          }
          e.target.value = ''
          this.$emit('updateTreeData', this.$refs.menu.model)
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    editNode (node) {
      node.startEditing()
      const lang = this.$store.state.setting.lang.current
      node.data.label[lang] = node.data.text
      node.isEditing = true
    },
    endEditLabel (node) {
      node.isEditing = false
    },
    removeNode (node) {
      if (window.confirm(this.locale.confirm_delete_menu)) {
        node.remove()
      }
    },
    addChildNode (node) {
      if (node.enabled()) {
        const newItem = this._.cloneDeep(this.defaultTree)
        newItem.data.id = UNIQUE.mid()
        node.append(newItem)
        node.states.expanded = true
        this.$emit('updateTreeData', this.$refs.menu.model)
      }
    },
    delIcon (node, icon2) {
      if (window.confirm(this.locale.confirm_delete_icon)) {
        if (icon2) {
          node.data.icon2 = ''
        } else {
          node.data.icon = ''
        }
        this.$emit('updateTreeData', this.$refs.menu.model)
      }
    },
    editLink (node) {
      this.$emit('setMode', 'link')
      this.$emit('setEditLink', node.data)
    },
    addList () {
      const newItem = this._.cloneDeep(this.defaultTree)
      newItem.data.id = UNIQUE.mid()
      this.$refs.menu.append(newItem)
      // this.listData.push(this.defaultTree)
      this.$emit('updateTreeData', this.$refs.menu.model)
    },
    isActive (data) {
      const result = data.id === this.activeLinkId
      return result
    },
    hasLink (data) {
      const result = (data.type === 'page' && data.pageId?.length) ||
                     (data.type === 'product' && data.productId?.length) ||
                     (data.type === 'reservation' && data.reservationId?.length) ||
                     (data.type === 'outlink' && Object.keys(data.url).filter(x => data.url[x]?.length).length > 0) ||
                     (data.type === 'shortcut' && data.shortcutId?.length) ||
                     (data.type.includes('interlock') && data.interlockId?.length)
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.menuIcon {
  position: relative;
  margin-right: 0.8em;
  text-align: center;
  border: 1px dashed $color-lgrey;
  border-radius: 2px;
  background-color: $bg-default;
  z-index: 1;
  .upload {
    display: block;
    position: relative;
    width: 28px;
    height: 28px;
    line-height: 28px;
    opacity: 0.5;
    cursor: pointer;
    .stkr {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 12px;
    }
  }
  img {
    width: 28px;
    height: 28px;
  }
  .editIcon {
    display: none;
    position: absolute;
    top: 50%;
    left: 100%;
    margin-left: 5px;
    color: $color-white;
    text-align: center;
    background-color: $color-dark;
    transform: translate(0, -50%);
    &.open {
      display: flex;
    }
    label {
      padding: 0.2em 1em;
      border: none;
      border-right: 1px solid rgba(0,0,0,0.5);
      opacity: 1;
    }
    button {
      min-width: 0;
      padding: 0.2em 1em;
      border: none;
      border-left: 1px solid rgba(255,255,255,0.2);
    }
  }
  &.active {
    background-color: transparent;
    background-image: linear-gradient(45deg, #eee 25%, transparent 25%), linear-gradient(-45deg, #eee 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #eee 75%), linear-gradient(-45deg, transparent 75%, #eee 75%);
    background-size: 16px 16px;
    background-position: 0 0, 0 8px, 8px -8px, -8px 0px;
    .upload {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .btnDel {
      position: absolute;
      top: -8px;
      left: 100%;
      width: 16px;
      height: 16px;
      margin-left: -6px;
      border-radius: 100%;
      background: $color-dark url('~@/assets/img/ico_close.svg') 50% 50% / 8px no-repeat;
    }
  }
}
.disaledDevice {
  label {
    display: inline-block;
    position: relative;
    width: 34px;
    margin-right: 5px;
    padding: 3px;
    border: 1px solid $color-green;
    cursor: pointer;
    &:after {
      content: "";
      position: absolute;
      top: -4px;
      right: -4px;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background: $color-green url('~@/assets/img/ico_checked.svg') 50% 50% / 8px no-repeat;
    }
    img {
      width: 24px;
      opacity: 0.5;
    }
  }
  :checked + label {
    border-color: $color-lgrey2;
    &:after {
      background-color: $color-lgrey;
    }
    img {
      opacity: 0.3;
    }
  }
}
</style>
